// extracted by mini-css-extract-plugin
export default {"card-wrapper":"PersonalCard_card-wrapper__guPBU","data-piece":"PersonalCard_data-piece__w39RJ","label":"PersonalCard_label__UYrmd","dates":"PersonalCard_dates__XBfAg"};